import React, { createContext, useContext, PropsWithChildren, useState, useMemo } from "react";

import { Security } from "@okta/okta-react";
import OktaAuth, { OktaAuthOptions } from "@okta/okta-auth-js";

const DEFAULT_OKTA_CONFIG = {
  issuer: "https://placeholder.okta.com/oauth2/default",
};

interface OktaContextType {
  oktaConfig: OktaAuthOptions;
  resetOktaConfig: () => void;
  setOktaConfig: React.Dispatch<React.SetStateAction<OktaAuthOptions | null>>;
}

const OktaContext = createContext<OktaContextType | undefined>(undefined);

export const OktaProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [oktaConfig, setOktaConfig] = useState<OktaAuthOptions>(DEFAULT_OKTA_CONFIG);

  const oktaAuth = useMemo(() => new OktaAuth(oktaConfig), [oktaConfig]);

  const resetOktaConfig = () => {
    setOktaConfig(DEFAULT_OKTA_CONFIG);
  };

  return (
    <OktaContext.Provider value={{ oktaConfig, resetOktaConfig, setOktaConfig }}>
      <Security oktaAuth={oktaAuth} onAuthRequired={() => {}} restoreOriginalUri={() => {}}>
        {children}
      </Security>
    </OktaContext.Provider>
  );
};

export const useOkta = () => {
  const context = useContext(OktaContext);
  if (context === undefined) {
    throw new Error("useOkta must be used within an OktaProvider");
  }
  return context;
};
